var _excluded = ["table", "keyColumn", "labelColumn", "iconColumn", "settings", "onChange", "onSelectionChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useCallback, useEffect, useMemo, useState } from 'react';
import { PICKER_TOP_OFFSET, usePickerItemScale } from '@deephaven/components';
import { TableUtils } from '@deephaven/jsapi-utils';
import Log from '@deephaven/log';
import { usePromiseFactory } from '@deephaven/react-hooks';
import useFormatter from "../../useFormatter.js";
import { getItemKeyColumn, getItemLabelColumn } from "./itemUtils.js";
import { useItemRowDeserializer } from "./useItemRowDeserializer.js";
import { useGetItemIndexByValue } from "../../useGetItemIndexByValue.js";
import useSearchableViewportData from "../../useSearchableViewportData.js";
import useWidgetClose from "../../useWidgetClose.js";
var log = Log.module('jsapi-components.usePickerProps');

/** Props that are derived by `usePickerProps`. */

/** 
 * Props that are passed through untouched. (should exclude all of the
 * destructured props passed into `usePickerProps` that are not in the spread
 * ...props)
) */

/** Props returned by `usePickerProps` hook. */

export function usePickerProps(_ref) {
  var _keyColumn$name;
  var tableSource = _ref.table,
    keyColumnName = _ref.keyColumn,
    labelColumnName = _ref.labelColumn,
    iconColumnName = _ref.iconColumn,
    settings = _ref.settings,
    onChange = _ref.onChange,
    onSelectionChange = _ref.onSelectionChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var _usePickerItemScale = usePickerItemScale(),
    itemHeight = _usePickerItemScale.itemHeight;
  var _useFormatter = useFormatter(settings),
    formatValue = _useFormatter.getFormattedString,
    timeZone = _useFormatter.timeZone;

  // `null` is a valid value for `selectedKey` in controlled mode, so we check
  // for explicit `undefined` to identify uncontrolled mode.
  var isUncontrolled = props.selectedKey === undefined;
  var _useState = useState(props.defaultSelectedKey),
    _useState2 = _slicedToArray(_useState, 2),
    uncontrolledSelectedKey = _useState2[0],
    setUncontrolledSelectedKey = _useState2[1];

  // Copy table so we can apply filters without affecting the original table.
  // (Note that this call is not actually applying any filters. Filter will be
  // applied in `useSearchableViewportData`.)
  var _usePromiseFactory = usePromiseFactory(TableUtils.copyTableAndApplyFilters, [tableSource]),
    tableCopy = _usePromiseFactory.data;
  useWidgetClose(tableCopy);
  var keyColumn = useMemo(() => tableCopy == null ? null : getItemKeyColumn(tableCopy, keyColumnName), [keyColumnName, tableCopy]);
  var labelColumn = useMemo(() => tableCopy == null || keyColumn == null ? null : getItemLabelColumn(tableCopy, keyColumn, labelColumnName), [keyColumn, labelColumnName, tableCopy]);
  var searchColumnNames = useMemo(() => labelColumn == null ? [] : [labelColumn.name], [labelColumn]);
  var deserializeRow = useItemRowDeserializer({
    table: tableCopy,
    iconColumnName,
    keyColumnName,
    labelColumnName,
    formatValue
  });
  var getItemIndexByValue = useGetItemIndexByValue({
    table: tableCopy,
    columnName: (_keyColumn$name = keyColumn === null || keyColumn === void 0 ? void 0 : keyColumn.name) !== null && _keyColumn$name !== void 0 ? _keyColumn$name : null,
    value: isUncontrolled ? uncontrolledSelectedKey : props.selectedKey
  });
  var getInitialScrollPosition = useCallback(/*#__PURE__*/_asyncToGenerator(function* () {
    var index = yield getItemIndexByValue();
    if (index == null) {
      return null;
    }
    return index * itemHeight + PICKER_TOP_OFFSET;
  }), [getItemIndexByValue, itemHeight]);
  var _useSearchableViewpor = useSearchableViewportData({
      reuseItemsOnTableResize: true,
      table: tableCopy,
      itemHeight,
      deserializeRow,
      searchColumnNames,
      timeZone
    }),
    onScroll = _useSearchableViewpor.onScroll,
    onSearchTextChange = _useSearchableViewpor.onSearchTextChange,
    setViewport = _useSearchableViewpor.setViewport,
    viewportData = _useSearchableViewpor.viewportData;
  useEffect(
  // Set viewport to include the selected item so that its data will load and
  // the real `key` will be available to show the selection in the UI.
  function setViewportFromSelectedKey() {
    var isCanceled = false;
    getItemIndexByValue().then(index => {
      if (index == null || isCanceled) {
        return;
      }
      setViewport(index);
    }).catch(err => {
      log.error('Error setting viewport from selected key', err);
    });
    return () => {
      isCanceled = true;
    };
  }, [getItemIndexByValue, settings, setViewport]);
  var onSelectionChangeInternal = useCallback(key => {
    var _ref3;
    // If our component is uncontrolled, track the selected key internally
    // so that we can scroll to the selected item if the user re-opens
    if (isUncontrolled) {
      setUncontrolledSelectedKey(key);
    }
    (_ref3 = onChange !== null && onChange !== void 0 ? onChange : onSelectionChange) === null || _ref3 === void 0 || _ref3(key);
  }, [isUncontrolled, onChange, onSelectionChange]);
  return _objectSpread(_objectSpread({}, props), {}, {
    normalizedItems: viewportData.items,
    showItemIcons: iconColumnName != null,
    getInitialScrollPosition,
    onChange: onSelectionChangeInternal,
    onScroll,
    onSearchTextChange
  });
}
export default usePickerProps;
//# sourceMappingURL=usePickerProps.js.map